const provinceSelectorEl = document.querySelector('.js-select-occupancy-rate-province');
const capacitySelectorEl = document.querySelector('.js-select-occupancy-rate-capacity');
const formEl = document.querySelector("[name='occupancy_rate_filter']");

if (provinceSelectorEl) {
    $(provinceSelectorEl).select2().on('change', () => {
        formEl.submit();
    });

    $(capacitySelectorEl).select2().on('change', () => {
        formEl.submit();
    });
}